import { REGULARS } from '../regulars';

export const VALIDATION = {
	shortName: {
		maxLength: 30,
		minLength: 2,
		pattern: REGULARS.shortName,
		allowedSymbols: 'letters A-Z, upper-lower cases, integ. 0-9',
	},
	formalName: {
		maxLength: 150,
		minLength: 3,
		pattern: REGULARS.formalName,
		allowedSymbols:
			'letters A-Z, upper- lover cases, integ. 0-9, special char. &():;"',
	},
	domainName: {
		maxLength: 253,
		minLength: 4,
		pattern: REGULARS.domainName,
		allowedSymbols:
			'letters A-Z, upper-lower cases, integ. 0-9, special char. -.',
	},
	clientUserCountLimit: {
		maxLength: 2,
	},
	surveyCountLimit: {
		maxLength: 7,
		minValue: 1,
	},
};
